import EmailInterceptor from './EmailInterceptor';

export default EmailInterceptor;
